<template>
  <tnc-popup :is-visible="isVisible" @close="$emit('close')">
    <div class="tnc-popup">
      <h2>Syarat dan Ketentuan:</h2>
      <img src="/static/img/blind-box/global/tnc-text-v4.webp" style="width: 100%" />
      <blind-box-button
        text="Close"
        :background-color="'#FF014A'"
        :text-color="'#FFFFFF'"
        style="width: 190px; margin: 60px auto 0 auto"
        @click="$emit('close')"
      />
    </div>
  </tnc-popup>
</template>

<script>
export default {
  components: {
    TncPopup: () => import('../ui/blind-box-popup.vue'),
    BlindBoxButton: () => import('../ui/blind-box-button.vue'),
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      bulletIcon: '/static/img/blind-box/global/list-icon.svg',
      SpIcon: '/static/img/blind-box/global/blind-box-sp-icon.svg',
    };
  },
};
</script>

<style lang="scss" scoped>
@import '../font/font.scss';
.tnc-popup {
  background: linear-gradient(180deg, #ffdbe3 0%, #9cde3c 100%);
  z-index: 3;
  margin: 0 100px;
  padding: 80px 60px;
  border-radius: 40px;

  h2 {
    font-weight: 900;
    font-size: 46px;
    letter-spacing: 0px;
    text-align: center;
    vertical-align: middle;
    margin: 0 0 60px 0;
    padding: 0;
    font-family: $lato-bold;
  }
}
</style>
